<template>
    <div class="notice-detail-page">
        <!-- 顶部信息 -->
        <div class="page-header">
            <div class="header-info">
                <span class="info-item">
                    <span class="label">招标项目名称：</span>
                    <span class="value">{{ projectName }}</span>
                </span>
                <span class="divider"></span>
                <span class="info-item">
                    <span class="label">招标项目编号：</span>
                    <span class="value">{{ projectCode }}</span>
                </span>
            </div>
        </div>

        <!-- 表单 -->
        <div class="form-container">
            <div class="section-header">
                <span class="title">招标公告信息</span>
            </div>
            
            <el-form ref="formRef" :model="form" :rules="rules" label-width="150px" class="notice-form">
                <el-form-item label="公告名称" prop="tenderNoticeName">
                    <el-input v-model="form.tenderNoticeName" placeholder="请输入公告名称" />
                </el-form-item>
                
                <el-form-item label="关联标段" prop="sections">
                    <el-checkbox-group v-model="selectedSectionCodes">
                        <el-checkbox 
                            v-for="section in sectionList" 
                            :key="section.bidSectionCode"
                            :label="section.bidSectionCode"
                        >
                            {{ section.bidSectionName }}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                
                <el-form-item label="公告发布日期" prop="noticeSendTime">
                    <el-date-picker
                        v-model="form.noticeSendTime"
                        type="datetime"
                        placeholder="请选择公告发布日期"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 100%"
                    />
                </el-form-item>
                
                <el-form-item label="文件获取开始时间" prop="biddingDocumentAcquisitionStartTime">
                    <el-date-picker
                        v-model="form.biddingDocumentAcquisitionStartTime"
                        type="datetime"
                        placeholder="请选择开始时间"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 100%"
                    />
                </el-form-item>
                
                <el-form-item label="文件获取结束时间" prop="biddingDocumentAcquisitionEndTime">
                    <el-date-picker
                        v-model="form.biddingDocumentAcquisitionEndTime"
                        type="datetime"
                        placeholder="请选择结束时间"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 100%"
                    />
                </el-form-item>
                
                <el-form-item label="投标截止时间" prop="bidDocumentSubmissionDeadline">
                    <el-date-picker
                        v-model="form.bidDocumentSubmissionDeadline"
                        type="datetime"
                        placeholder="请选择投标截止时间"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 100%"
                    />
                </el-form-item>
                
                <el-form-item label="公告正文" prop="noticeContent">
                    <RichTextEditor v-model="form.noticeContent" :height="300" placeholder="请输入公告正文..." toolbar-type="default" />
                </el-form-item>
                
                <el-form-item label="附件上传">
                    <div class="upload-area">
                        <el-button @click="handleUploadAttach">
                            <i class="el-icon-upload2"></i> 上传附件
                        </el-button>
                        <span class="upload-tip">支持pdf、word、excel格式，单个文件不超过50MB</span>
                    </div>
                    <div v-if="attachFileList && attachFileList.length > 0" class="attach-file-list">
                        <div v-for="(file, fIndex) in attachFileList" :key="fIndex" class="attach-file-item">
                            <span class="attach-file-name">{{ file.name }}</span>
                            <el-progress v-if="file.uploading" :percentage="file.progress"></el-progress>
                            <span v-if="file.uploaded && !file.uploading" class="attach-file-status">已上传</span>
                            <span v-if="!file.uploading && !file.uploaded && file.error" class="attach-file-error">上传失败</span>
                            <i class="el-icon-close attach-file-remove" @click="removeAttachFile(fIndex)"></i>
                        </div>
                    </div>
                </el-form-item>
            </el-form>

            <!-- 底部按钮 -->
            <div class="form-footer">
                <el-button @click="handleCancel">取消</el-button>
                <el-button type="primary" @click="handleSave" :loading="saveLoading">保存</el-button>
            </div>
        </div>
        
        <!-- 隐藏的文件上传input -->
        <input type="file" ref="attachFileInput" style="display: none" @change="handleAttachFileChange" accept=".pdf,.doc,.docx,.xls,.xlsx" />
    </div>
</template>

<script>
import { Api_GetSemiProcessTenderNoticeDetail, Api_SaveSemiProcessTenderNotice } from '@/api/modules/semiProcess'
import { doFileUpload } from '@/utils/upload/fileUploadHelper'
import RichTextEditor from '@/components/common/RichTextEditor.vue'

export default {
    name: 'AgentPublishesNoticeDetails',

    components: {
        RichTextEditor
    },

    data() {
        return {
            projectName: '',
            projectCode: '',
            sectionList: [],
            selectedSectionCodes: [],
            attachFileList: [],
            fileGuid: new Date().getTime() + Math.random().toString().substr(2, 5),
            saveLoading: false,
            form: {
                noticeNature: this.$route.query.noticeNature,
                projectCode: this.$route.query.projectCode,
                tenderNoticeName: '',
                noticeSendTime: '',
                biddingDocumentAcquisitionStartTime: '',
                biddingDocumentAcquisitionEndTime: '',
                bidDocumentSubmissionDeadline: '',
                noticeContent: '',
                sections: []
            },
            rules: {
                tenderNoticeName: [
                    { required: true, message: '请输入公告名称', trigger: 'blur' }
                ],
                noticeSendTime: [
                    { required: true, message: '请选择公告开始时间', trigger: 'change' }
                ],
                biddingDocumentAcquisitionStartTime: [
                    { required: true, message: '请选择招标文件获取开始时间', trigger: 'change' }
                ],
                biddingDocumentAcquisitionEndTime: [
                    { required: true, message: '请选择招标文件获取结束时间', trigger: 'change' }
                ],
                bidDocumentSubmissionDeadline: [
                    { required: true, message: '请选择投标截止时间', trigger: 'change' }
                ]
            }
        }
    },

    created() {
        this.projectName = this.$route.query.projectName || ''
        this.projectCode = this.$route.query.projectCode || ''
        this.getDetail()
    },

    methods: {
        getDetail() {
            Api_GetSemiProcessTenderNoticeDetail({
                projectCode: this.projectCode
            }).then(res => {
                if (res.code === 200 && res.data) {
                    const data = res.data
                    this.form.tenderNoticeName = data.tenderNoticeName || ''
                    this.form.noticeSendTime = data.noticeSendTime || ''
                    this.form.biddingDocumentAcquisitionStartTime = data.biddingDocumentAcquisitionStartTime || ''
                    this.form.biddingDocumentAcquisitionEndTime = data.biddingDocumentAcquisitionEndTime || ''
                    this.form.bidDocumentSubmissionDeadline = data.bidDocumentSubmissionDeadline || ''
                    this.sectionList = data.sections || []
                    this.selectedSectionCodes = (data.sections || [])
                        .filter(item => item.isSelected === 1)
                        .map(item => item.bidSectionCode)
                    this.form.noticeContent = data.noticeContent || ''
                    this.fileGuid = data.fileGuid || this.fileGuid
                }
            }).catch(() => {
                this.$message.error('获取详情失败')
            })
        },

        handleCancel() {
            this.$router.back()
        },

        handleSave() {
            this.$refs.formRef.validate(valid => {
                if (valid) {
                    this.saveLoading = true
                    // 构建sections数组
                    const selectedSections = this.sectionList
                        .filter(section => this.selectedSectionCodes.includes(section.bidSectionCode))
                        .map(section => ({
                            bidSectionCode: section.bidSectionCode,
                            bidSectionName: section.bidSectionName
                        }))
                    
                    const submitData = {
                        ...this.form,
                        sections: selectedSections,
                        fileGuid: this.fileGuid,
                    }
                    
                    Api_SaveSemiProcessTenderNotice(submitData).then(res => {
                        this.saveLoading = false
                        if (res.code === 200) {
                            this.$message.success('保存成功')
                            this.$router.back()
                        } else {
                            this.$message.error(res.msg || '保存失败')
                        }
                    }).catch(() => {
                        this.saveLoading = false
                    })
                }
            })
        },

        // 上传附件
        handleUploadAttach() {
            if (this.attachFileList.length >= 5) {
                this.$message.warning('最多只能上传5个附件')
                return
            }
            this.$refs.attachFileInput.click()
        },

        // 处理附件选择
        async handleAttachFileChange(event) {
            const files = Array.from(event.target.files)
            if (files.length === 0) return

            const file = files[0]
            if (!this.checkFileType(file.name)) {
                this.$message.error(`文件 ${file.name} 格式不正确！`)
                event.target.value = ''
                return
            }
            if (file.size / 1024 / 1024 > 50) {
                this.$message.error(`文件 ${file.name} 大小不能超过50MB！`)
                event.target.value = ''
                return
            }

            const fileItem = {
                name: file.name,
                size: file.size,
                uploading: true,
                uploaded: false,
                progress: 0,
                fileGuid: '',
                uploadFileId: '',
                filePath: '',
                error: false
            }
            this.attachFileList.push(fileItem)

            try {
                await doFileUpload(file, {
                    fileBindId: this.fileGuid,
                    onProgress: (percentage) => {
                        fileItem.progress = percentage
                    },
                    onSuccess: (res) => {
                        fileItem.uploading = false
                        fileItem.uploaded = true
                        fileItem.fileGuid = res.fileGuid
                        fileItem.uploadFileId = res.uploadFileId
                        fileItem.filePath = res.filePath
                        this.$message.success(`文件 ${file.name} 上传成功`)
                    },
                    onError: (error) => {
                        fileItem.uploading = false
                        fileItem.error = true
                        this.$message.error(`文件 ${file.name} 上传失败: ${error.message}`)
                    }
                })
            } catch (error) {
                fileItem.uploading = false
                fileItem.error = true
                this.$message.error(`文件 ${file.name} 上传失败`)
            }

            event.target.value = ''
        },

        // 检查文件类型
        checkFileType(fileName) {
            const ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase()
            const allowedTypes = ['.pdf', '.doc', '.docx', '.xls', '.xlsx']
            return allowedTypes.includes(ext)
        },

        // 删除附件
        removeAttachFile(index) {
            this.attachFileList.splice(index, 1)
        }
    }
}
</script>

<style lang="less" scoped>
.notice-detail-page {
    background: #f5f5f5;
    min-height: 100vh;
    padding: 20px;
}

.page-header {
    background: #fff;
    padding: 16px 20px;
    margin-bottom: 12px;
}

.header-info {
    display: flex;
    align-items: center;
}

.info-item {
    font-size: 14px;
}

.label {
    color: #666;
}

.value {
    color: #333;
}

.divider {
    width: 1px;
    height: 14px;
    background: #ddd;
    margin: 0 20px;
}

.form-container {
    background: #fff;
    padding: 20px;
}

.section-header {
    padding-bottom: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid #eee;
}

.title {
    font-size: 15px;
    font-weight: 500;
    color: #333;
}


.el-checkbox {
    margin-right: 16px;
}

.upload-area {
    display: flex;
    align-items: center;
    gap: 12px;
}

.upload-tip {
    font-size: 12px;
    color: #999;
}

.attach-file-list {
    margin-top: 12px;
}

.attach-file-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 0;
}

.attach-file-name {
    flex: 1;
    font-size: 13px;
    color: #333;
}

.attach-file-status {
    font-size: 12px;
    color: #67c23a;
}

.attach-file-error {
    font-size: 12px;
    color: #f56c6c;
}

.attach-file-remove {
    cursor: pointer;
    color: #999;
    &:hover {
        color: #f56c6c;
    }
}

.form-footer {
    padding-top: 24px;
    margin-top: 24px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: center;
    gap: 12px;
}
</style>
